import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import FarmList from './FarmList';
import FarmForm from './FarmForm';
import ZoneList from './ZoneList';
import ZoneForm from './ZoneForm';
import ZoneDetail from './ZoneDetail';

const FarmsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<FarmList />} />
      <Route path="new" element={<FarmForm />} />
      <Route path=":farmId" element={<FarmForm />} />
      <Route path=":farmId/zones" element={<ZoneList />} />
      <Route path=":farmId/zones/new" element={<ZoneForm />} />
      <Route path=":farmId/zones/:zoneId" element={<ZoneDetail />} />
      <Route path=":farmId/zones/:zoneId/edit" element={<ZoneForm />} />
      <Route path="*" element={<Navigate to="/farms" replace />} />
    </Routes>
  );
};

export default FarmsPage;
